import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/managerFiles.svg',
})
export class ManagerFilesComponent {}
